module.exports = __webpack_public_path__ + "static/hero-d02c444de92a080985a6974b8a213dfe.svg";